module.exports = __webpack_public_path__ + "static/media/email_1.11e21090.png";